export const alert = {
  title: { en: 'Alert', ko: '알림', fr: '' },
};
